export default {
  "menu.welcome": "首页",
  "menu.more-blocks": "更多区块",
  "menu.home": "首页",
  "menu.admin": "管理页",
  "menu.admin.sub-page": "二级管理页",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.register-result": "注册结果",
  "menu.dashboard": "首页",
  "menu.dashboard.analysis": "分析页",
  "menu.dashboard.monitor": "监控页",
  "menu.dashboard.workplace": "工作台",
  "menu.clear-static-cache": "站点缓存清理",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "表单页",
  "menu.form.basic-form": "基础表单",
  "menu.form.step-form": "分步表单",
  "menu.form.step-form.info": "分步表单（填写转账信息）",
  "menu.form.step-form.confirm": "分步表单（确认转账信息）",
  "menu.form.step-form.result": "分步表单（完成）",
  "menu.form.advanced-form": "高级表单",
  "menu.list": "列表页",
  "menu.list.table-list": "查询表格",
  "menu.list.basic-list": "标准列表",
  "menu.list.card-list": "卡片列表",
  "menu.list.search-list": "搜索列表",
  "menu.list.search-list.articles": "搜索列表（文章）",
  "menu.list.search-list.projects": "搜索列表（项目）",
  "menu.list.search-list.applications": "搜索列表（应用）",
  "menu.profile": "详情页",
  "menu.profile.basic": "基础详情页",
  "menu.profile.advanced": "高级详情页",
  "menu.result": "结果页",
  "menu.result.success": "成功页",
  "menu.result.fail": "失败页",
  "menu.exception": "异常页",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "触发错误",
  "menu.account": "个人页",
  "menu.account.center": "个人中心",
  "menu.account.settings": "个人设置",
  "menu.account.trigger": "触发报错",
  "menu.account.logout": "退出登录",
  "menu.editor": "图形编辑器",
  "menu.editor.flow": "流程编辑器",
  "menu.editor.mind": "脑图编辑器",
  "menu.editor.koni": "拓扑编辑器",
  "menu.order-list.title": "订单列表",
  "menu.topup-list.title": "话费充值",
  "menu.user-admin": "会员管理",
  "menu.user-admin.user-list": "会员列表",
  "menu.user-admin.user-risk-admin": "会员风控管理",
  "menu.user-admin.user-tags-admin": "会员标签管理",
  "menu.user-admin.user-group-admin": "会员分组管理",
  "menu.user-admin.user-vip-admin": "会员VIP等级管理",

  "menu.user-admin.deposit-bonus-admin": "充值促销优惠管理",
  "menu.user-admin.promotions-admin": "促销活动管理",
  "menu.user-admin.user-retain": "会员留存",
  "menu.user-list": "用户列表",
  "menu.report-lists": "报表列表",
  "menu.report-lists.bet-order": "投注订单记录",
  "menu.report-lists.bet-reports": "投注报表",
  "menu.report-lists.wallet-change-list": "钱包变动记录",
  "menu.report-lists.deposit-record": "存款记录",
  "menu.report-lists.ltv": "LTV",
  "menu.report-lists.k-factor": "K-Factor",
  "menu.report-lists.retention-rate": "留存率",
  "menu.report-lists.bonus-record": "奖金记录",
  "menu.agent-admin": "代理管理",
  "menu.agent-admin.agent-approval": "代理审批",
  "menu.agent-admin.agent-approval-history": "代理审批记录",
  "menu.agent-admin.agent-details": "代理详情",
  "menu.agent-admin.agent-report": "代理报表",
  "menu.agent-admin.agent-cashback-admin": "代理反现管理",
  "menu.financial-statements": "财务报表",
  "menu.financial-statements.deposit-record": "存款记录",
  "menu.operational-report": "运营报表",
  "menu.operational-report.bet-order": "投注订单记录",
  "menu.operational-report.bet-reports": "投注报表",
  "menu.operational-report.wallet-change-list": "钱包变动记录",
  "menu.operational-report.ltv": "LTV",
  "menu.operational-report.k-factor": "K-Factor",
  "menu.operational-report.retention-rate": "留存率",
  "menu.operational-report.bonus-record": "奖金记录",
  // "menu.operational-report.luckywheel-daily-report": "幸运轮盘日报",
  "menu.operational-report.luck-wheel-daily-statistics-report": "幸运轮盘日报",
  "menu.game-admin": "游戏管理",
  "menu.game-admin.games-manage": "游戏列表",
  "menu.game-admin.game-actions": "游戏操作",
  "menu.game-admin.tags-admin": "标签管理",
  "menu.withdraw-admin": "资金管理",
  "menu.withdraw-admin.withdraw-approval": "提款审批",
  "menu.withdraw-admin.withdraw-history": "会员提款",
  "menu.withdraw-admin.member-deposits": "会员存款",
  "menu.withdraw-admin.wallet-record": "钱包记录",
  "menu.operations-section": "运营版块",
  "menu.report-section": "报表版块",
  "menu.config-section": "配置板块",
  "menu.config-admin": "配置管理",
  "menu.config-admin.betting-analysis": "投注分析配置",

  "menu.config-admin.adjust-app-config": "AdjustAPP配置",
  "menu.bonus-admin.luckydraw-config": "幸运抽奖配置",
  "menu.config-admin.about-admin": "关于我们管理",
  "menu.config-admin.left-menu-admin": "左侧菜单配置",
  "menu.config-admin.pixels-management": "像素管理",
  "menu.config-admin.airdrop-config": "空投配置",
  "menu.config-admin.email-marketing": "邮件营销",
  "menu.config-admin.valid-bet-config": "有效投注管理",

  "menu.statistical-reports": "统计报表",
  "menu.record-admin": "记录管理",
  "menu.record-admin.wallet-change-list": "账变记录",
  "menu.record-admin.activity-bonus-record": "活动奖金记录",
  "menu.record-admin.bet-order": "投注记录",
  "menu.record-admin.bonus-record": "奖金记录",
  "menu.record-admin.redemption-code-record": "兑换码记录",
  "menu.record-admin.checkin-record": "签到记录",
  "menu.record-admin.free-spin-record": "免费旋转记录",
  "menu.record-admin.luckywheel-record": "幸运轮盘记录",
  "menu.record-admin.login-history": "登陆记录",
  "menu.record-admin.operation-record": "操作记录",
  "menu.statistical-reports.luckywheel-daily-report": "幸运轮盘日报",
  "menu.statistical-reports.user-retain": "会员留存报表",
  "menu.statistical-reports.daily-reports": "日报报表",
  "menu.statistical-reports.user-reports": "用户报表",
  "menu.statistical-reports.channel-reports": "渠道来源统计",
  "menu.statistical-reports.retention-rate": "留存率",
  "menu.statistical-reports.retention-rate-report": "留存率(投注口径)",
  "menu.statistical-reports.retention-rate-deposit": "留存率(存款口径)",
  "menu.statistical-reports.k-factor": "K-Factor报表",
  "menu.statistical-reports.ltv": "LTV报表",
  "menu.message-admin": "消息管理",
  "menu.bonus-admin": "优惠管理",
  "menu.bonus-admin.deposit-bonus-admin": "充值促销优惠管理",
  "menu.bonus-admin.promotions-admin": "促销活动管理",
  "menu.bonus-admin.bonus-list": "优惠列表",
  "menu.bonus-admin.redemption-code": "兑换码配置",
  "menu.bonus-admin.checkin-config": "签到配置",
  "menu.bonus-admin.free-spin-config": "免费旋转配置",
  "menu.bonus-admin.luckywheel-config": "幸运轮盘配置",
  "menu.bonus-admin.daily-rebate-admin": "每日返现管理",
  "menu.bonus-admin.activity-bonus": "活动奖金配置",
  "menu.bonus-admin.invite-box-admin": "邀请宝箱管理",
  "menu.bonus-admin.task-admin": "任务管理",
  "menu.betting-analysis": "投注分析",
  "menu.betting-analysis.betting-analysis": "投注分析",
  "menu.redemption-code": "兑换码管理",
  "menu.redemption-code.config-list": "兑换码配置",
  "menu.redemption-code.record": "兑换码记录",
  "menu.checkin-admin": "签到管理",
  "menu.checkin-admin.config-list": "签到配置",
  "menu.checkin-admin.checkin-record": "签到记录",
  "menu.gem-mall-admin": "宝石商城管理",
  "menu.gem-mall-admin.goods-type-admin": "宝石商品类型管理",
  "menu.gem-mall-admin.goods-admin": "宝石商品管理",
  "menu.gem-mall-admin.exchange-mall-admin": "宝石兑换商城管理",
  "menu.gem-mall-admin.exchange-tags-admin": "宝石兑换商城标签管理",
  "menu.payment-admin": "支付管理",
  "menu.payment-admin.payment-platform-admin": "三方支付平台管理",
  "menu.free-spin-admin": "免费旋转管理",
  "menu.free-spin-admin.config": "免费旋转配置",
  "menu.free-spin-admin.free-spin-config": "免费旋转配置",
  "menu.free-spin-admin.free-spin-record": "免费旋转记录",
  "menu.free-spin-admin.record": "免费旋转记录",
  "menu.luckywheel-admin": "幸运轮盘管理",
  "menu.luckywheel-admin.luckywheel-config": "幸运轮盘配置",
  "menu.luckywheel-admin.luckywheel-record": "幸运轮盘记录",
  "menu.luckywheel-admin.luckywheel-daily-report": "幸运轮盘日报",
  "menu.activity-bonus": "活动奖金管理",
  "menu.activity-bonus.config-list": "活动奖金配置",
  "menu.pwa-notification-admin": "PWA通知管理",
  "menu.pwa-notification-admin.pwa-device-list": "PWA设备列表",
  "menu.pwa-notification-admin.pwa-notification-list": "PWA通知列表",
  "menu.pwa-notification-admin.pwa-notification-task": "PWA通知任务列表",
};
